<mat-card appearance="outlined" class="mat-card-fix">
    <form tabindex="0" class="fix-editor">
        <se-autocomplete
                         #autocomplete
                         [items]="items"
                         [value]="value"
                         [required]="required"
                         [isWithLabel]="false"
                         (valueChange)="updateValue($event)"
                         (optionsClickedEvent)="optionClicked($event)"
                         >
        </se-autocomplete>
    </form>
</mat-card>
